import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { LeavePolicyService } from '../../services/leave-policy.service'
import { catchError, exhaustMap, map, of, switchMap, tap } from 'rxjs'
import {
  deleteAssignedTo,
  deleteAssignedToFailure,
  deleteAssignedToSuccess,
  loadAssignedTo,
  loadAssignedToFailure,
  loadAssignedToSuccess,
  loadLeavePolicyById,
  loadLeavePolicyByIdFailure,
  loadLeavePolicyByIdSuccess,
  loadUnAssignedTo,
  loadUnAssignedToSuccess
} from './leave-policy.actions'
import { ToastrService } from 'ngx-toastr'

export const loadLeavePolicyById$ = createEffect(
  (actions$ = inject(Actions), leavePolicyService = inject(LeavePolicyService)) =>
    actions$.pipe(
      ofType(loadLeavePolicyById),
      switchMap(({ id }) =>
        leavePolicyService.getLeavePolicyById(id).pipe(
          map(leavepolicy => {
            // console.log('role', role)
            return loadLeavePolicyByIdSuccess({ leavepolicy })
          }),
          catchError(error => of(loadLeavePolicyByIdFailure({ error: error.message })))
        )
      )
    ),
  { functional: true, dispatch: true }
)

export const loadAssignedTo$ = createEffect(
  (
    actions$ = inject(Actions),
    leavePolicyService = inject(LeavePolicyService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(loadAssignedTo),
      // tap(action => console.log('Params:', action.params)),
      tap(),
      switchMap(action =>
        leavePolicyService
          .getAssignedTo(action.leavePolicyId, action.params, action.page, action.limit)
          .pipe(
            map(res =>
              loadAssignedToSuccess({
                assignedTo: res.assignedLeavePolicies,
                totalCount: res.totalCount
              })
            ),
            catchError(error => {
              toastr.error('Failed to fetch users: ' + error.error.message)
              return of(loadAssignedToFailure({ error: error.error.message }))
            })
          )
      )
    ),
  { functional: true }
)

export const loadUnAssignedTo$ = createEffect(
  (
    actions$ = inject(Actions),
    leavePolicyService = inject(LeavePolicyService),
    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(loadUnAssignedTo),
      switchMap(action =>
        leavePolicyService
          .getUnAssignedTo(action.leavePolicyId, action.params, action.page, action.limit)
          .pipe(
            map(res =>
              loadUnAssignedToSuccess({
                unassignedTo: res.users,
                totalUserCount: res.totalCount
              })
            ),
            catchError(error => {
              toastr.error('Failed to fetch users: ' + error.error.message)
              return of(loadAssignedToFailure({ error: error.error.message }))
            })
          )
      )
    ),
  { functional: true }
)

export const deleteAssignedTo$ = createEffect(
  (
    actions$ = inject(Actions),
    leavePolicyService = inject(LeavePolicyService),

    toastr = inject(ToastrService)
  ) =>
    actions$.pipe(
      ofType(deleteAssignedTo),
      exhaustMap(action =>
        leavePolicyService.deleteAssignedTo(action.id).pipe(
          map(d => deleteAssignedToSuccess({ assignedTo: d })),
          
          catchError(error => {
            toastr.error('Failed to delete assignment: ' + error.message)
            return of(deleteAssignedToFailure({ error }))
          })
        )
      )
    ),
  { functional: true }
)

// export const deleteAssignedTo$ = createEffect(
//   (
//     actions$ = inject(Actions),
//     leavePolicyService = inject(LeavePolicyService),
//     toastr = inject(ToastrService)
//   ) =>
//     actions$.pipe(
//       ofType(deleteAssignedTo),
//       exhaustMap(action =>
//         leavePolicyService.deleteAssignedTo(action.id).pipe(
//           // ✅ IMPORTANT FIX: pass id instead of response
//           map(() => deleteAssignedToSuccess({ id: action.id })),

//           catchError(error => {
//             toastr.error('Failed to delete assignment: ' + error.message)
//             return of(deleteAssignedToFailure({ error }))
//           })
//         )
//       )
//     ),
//   { functional: true }
// )

export const leavePolicyEffects = {
  loadLeavePolicyById$,
  loadAssignedTo$,
  loadUnAssignedTo$,
  deleteAssignedTo$
}
